import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import { QA_NAME_BLOCK_EDIT_DISABLED } from './RentalPortalBlockDisabledEditButton.constants'

import EditIcon from '../../../icons/edit.svg'

function RentalPortalBlockDisabledEditButton({
  tooltipKey = 'RentalPortal.BlockEditNotAllowedTooltipKey',
}) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      disabled
      isGrey
      beforeIconProps={{ Icon: EditIcon }}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_BLOCK_EDIT_DISABLED}
      tooltip={t(tooltipKey)}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default RentalPortalBlockDisabledEditButton
